export const tagsList = [
  { value: '{ClaimNo}', code: '01' },
  { value: '{InsuredFullName}', code: '02' },
  { value: '{InsuredName1}', code: '03' },
  { value: '{InsuredName2}', code: '04' },
  { value: '{InsuredName3}', code: '05' },
  { value: '{InsuredName4}', code: '06' },
  { value: '{ClaimAgent}', code: '07' },
  { value: '{ClaimAgentFullName}', code: '08' },
  { value: '{ClaimAgentName1}', code: '09' },
  { value: '{ClaimAgentName2}', code: '10' },
  { value: '{ClaimAgentName3}', code: '11' },
  { value: '{ClaimAgentName4}', code: '12' },
  { value: '{LossDate}', code: '13' },
  { value: '{PolicyNo}', code: '14' },
  { value: '{VehicleNo}', code: '15' },
  { value: '{VesselName}', code: '16' },
  { value: '{InsuredFullAddress}', code: '17' },
  { value: '{InsuredAddress1}', code: '18' },
  { value: '{InsuredAddress2}', code: '19' },
  { value: '{InsuredAddress3}', code: '20' },
  { value: '{InsuredAddress4}', code: '21' },
  { value: '{InsuredPostcode}', code: '22' },
  { value: '{AuthorisedClaimsSignature}', code: '29' }
]

// Only available if
// [DocumentHeadingTextParam.DocumentHeadingNo] equals "623"
export const tagsList1 = [
  { value: '{ServiceProviderCurrency}', code: '23' },
  { value: '{ServiceProviderAmount}', code: '24' },
  { value: '{ServiceProviderAmountLocal}', code: '25' }
]

// Only available if
// [DocumentHeadingTextParam. DocumentHeadingNo] equals "624" & "625"
export const tagsList2 = [
  { value: '{PaymentCurrency}', code: '26' },
  { value: '{PaymentAmount}', code: '27' },
  { value: '{PaymentAmountLocal}', code: '28' }
]

export const docNoList = [
  { code: '001', value: 'Policy Schedule', codeValue: '001 - Policy Schedule' },
  { code: '002', value: 'Direct Business Debit Note', codeValue: '002 - Direct Business Debit Note' },
  { code: '003', value: 'RI Inward Debit Note', codeValue: '003 - RI Inward Debit Note' },
  { code: '004', value: 'Direct Business Credit Note', codeValue: '004 - Direct Business Credit Note' },
  { code: '005', value: 'RI Inward Credit Note', codeValue: '005 - RI Inward Credit Note' },
  { code: '006', value: 'Direct Business List of Instalments', codeValue: '006 - Direct Business List of Instalments' },
  { code: '007', value: 'RI Inwards List of Instalments', codeValue: '007 - RI Inwards List of Instalments' },
  { code: '011', value: 'RI Applications', codeValue: '011 - RI Applications' },
  { code: '012', value: 'NCB Letters', codeValue: '012 - NCB Letters' },
  { code: '020', value: 'Upper Renewal Notice', codeValue: '020 - Upper Renewal Notice' },
  { code: '021', value: 'Lower Renewal Notice', codeValue: '021 - Lower Renewal Notice' },
  { code: '022', value: 'Premium GST Tax Invoice', codeValue: '022 - Premium GST Tax Invoice' },
  { code: '023', value: 'Commission 1 GST Tax Invoice', codeValue: '023 - Commission 1 GST Tax Invoice' },
  { code: '024', value: 'Commission 2/3 GST Tax Invoice', codeValue: '024 - Commission 2/3 GST Tax Invoice' },
  { code: '030', value: 'Marine Cover Notes', codeValue: '030 - Marine Cover Notes' },
  {
    code: '036',
    value: 'Coinsurance Inward Service Fee Debit/Credit Note',
    codeValue: '036 - Coinsurance Inward Service Fee Debit/Credit Note'
  },
  { code: '037', value: 'Non-motor CI', codeValue: '037 - Non-motor CI' },
  { code: '038', value: 'Auto Renewal Cover Letter', codeValue: '038 - Auto Renewal Cover Letter' },
  { code: '500', value: 'Claims Payment Voucher', codeValue: '500 - Claims Payment Voucher' },
  { code: '501', value: 'Claims Receipt', codeValue: '501 - Claims Receipt' },
  { code: '502', value: 'Claims Debit Note', codeValue: '502 - Claims Debit Note' },
  { code: '503', value: 'Claims Credit Note', codeValue: '503 - Claims Credit Note' },
  { code: '504', value: 'Claims Remittance Advice', codeValue: '504 - Claims Remittance Advice' },
  { code: '505', value: 'Claims RI Recovery Debit Note (Active Claims)', codeValue: '505 - Claims RI Recovery Debit Note (Active Claims)' },
  { code: '506', value: 'Claims RI Recovery Debit Note (Closed Claims)', codeValue: '506 - Claims RI Recovery Debit Note (Closed Claims)' },
  { code: '507', value: 'Claims RI Recovery Credit Note (Active Claims)', codeValue: '507 - Claims RI Recovery Credit Note (Active Claims)' },
  { code: '508', value: 'Claims RI Recovery Credit Note (Closed Claims)', codeValue: '508 - Claims RI Recovery Credit Note (Closed Claims)' },
  { code: '509', value: 'Preliminary Loss Advice', codeValue: '509 - Preliminary Loss Advice' },
  { code: '510', value: 'Revised Loss Advice', codeValue: '510 - Revised Loss Advice' },
  { code: '511', value: 'Settled Claims Advice', codeValue: '511 - Settled Claims Advice' },
  { code: '512', value: 'Reopened Claim Advice', codeValue: '512 - Reopened Claim Advice' },
  { code: '513', value: 'Claims Face Sheet', codeValue: '513 - Claims Face Sheet' },
  { code: '514', value: 'Claim Acknowledgement Letter', codeValue: '514 - Claim Acknowledgement Letter' },
  { code: '600', value: 'Receipt', codeValue: '600 - Receipt' },
  { code: '601', value: 'Payment Vouchers', codeValue: '601 - Payment Vouchers' },
  { code: '602', value: 'Debit Note', codeValue: '602 - Debit Note' },
  { code: '603', value: 'Credit Note', codeValue: '603 - Credit Note' },
  { code: '610', value: 'Statement of Account', codeValue: '610 - Statement of Account' },
  { code: '620', value: 'Claims Acknowledgement Letter', codeValue: '620 - Claims Acknowledgement Letter' },
  { code: '622', value: 'Documentation Request Letter', codeValue: '622 - Documentation Request Letter' },
  { code: '623', value: 'Service Provider Appointment Letter', codeValue: '623 - Service Provider Appointment Letter' },
  { code: '624', value: 'Offer Settlement Letter', codeValue: '624 - Offer Settlement Letter' },
  { code: '625', value: 'Discharge Voucher', codeValue: '625 - Discharge Voucher' },
  { code: '626', value: 'Subrogation Form', codeValue: '626 - Subrogation Form' },
  { code: '627', value: 'Counter Guarantee Letter', codeValue: '627 - Counter Guarantee Letter' },
  { code: '628', value: 'Third Party Claimant PDPA', codeValue: '628 - Third Party Claimant PDPA' },
  { code: '891', value: 'UOB Proposal', codeValue: '891 - UOB Proposal' }
]
